module.exports = __webpack_public_path__ + "static/releaseofinformation-60c3d9e86891e906a2af51c69a58cffe.pdf";